import { render, staticRenderFns } from "./StickyNavbar.vue?vue&type=template&id=af56b16a&scoped=true"
import script from "./StickyNavbar.vue?vue&type=script&lang=ts"
export * from "./StickyNavbar.vue?vue&type=script&lang=ts"
import style0 from "./StickyNavbar.vue?vue&type=style&index=0&id=af56b16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56b16a",
  null
  
)

export default component.exports